import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { tileUninstallMutate } from 'queries';
import { fetchInstalledApps } from 'actions/registry';

export default new AsyncActionHandler({
  name: 'mark_tile_removed',
  stateProp: 'markTileRemoved',
  handler: (id) => async (dispatch) => {
    await apollo.mutate({
      mutation: tileUninstallMutate,
      variables: {
        id
      }
    });

    await dispatch(fetchInstalledApps());
  }
});
